<div class="container">
  <div class="content-wrapper">
    <div class="user-signup">
      <div #isNavigated>
        <div class="content-wrapper">
          <h5 class="modal-title fech_hed" id="exampleModalCenterTitle">
            Sign Up / Create Account
          </h5>
          <div class="col-lg-12 row mt-2">
            <div class="col-md-6">
              <button
                [ngClass]="userType === 'user' ? 'active' : ''"
                id="userbtn"
                (click)="switchToUserOrAgent('user', true)"
                type="button"
                class="btn btn-block btn-outline-primary"
                [disabled]="isDisabled"
              >
                User
              </button>
            </div>
            <div class="col-md-6">
              <button
                [ngClass]="userType === 'agent' ? 'active' : ''"
                id="agentbtn"
                (click)="switchToUserOrAgent('agent')"
                type="button"
                class="btn btn-block btn-outline-primary"
              >
                Agent
              </button>
            </div>

            <p class="mb-3 ml-1-enq mt-2 text-justify">
              Become a valued partner in our travel community! By signing up as
              an agent, you gain privileged access to our extensive flight
              inventory, and competitive commissions designed to streamline your
              booking process. Registering is the first step to enjoying
              benefits. Start your journey with us today.
            </p>
          </div>
          <ng-container *ngIf="userType === 'user'">
            <ng-container *ngTemplateOutlet="user"></ng-container>
          </ng-container>
          <ng-container *ngIf="userType === 'agent'">
            <ng-container *ngTemplateOutlet="agent"></ng-container>
          </ng-container>
        </div>
      </div>
    </div>

          <ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-spin-clockwise"
  [fullScreen]="true"
></ngx-spinner>
  </div>
</div>

<ng-template #user>
  <form
    [formGroup]="registrationForm"
    class="payment-form-wrapper"
    (ngSubmit)="onSubmit()"
  >
    <div class="pregistrationFormt-25 ph-30">
      <div class="row gap-20 mb-0 form-container">
        <div class="col-md-12">
          <div class="form-group mt-15">
            <label>User ID <span class="help-block">*</span></label>
            <input
              type="text"
              class="form-control form-bg-light"
              formControlName="UserId"
              minlength="6"
              maxlength="16"
              id="uniqueUserID"
              (keyup)="checkVal()"
              (blur)="checkUserIDExist()"
            />
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('UserId').touched &&
                registrationForm.get('UserId').hasError('required')
              "
              class="text text-danger"
            >
              User ID is required
            </span>
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('UserId').touched &&
                registrationForm.get('UserId').hasError('minlength')
              "
              class="text text-danger input"
            >
              User ID between 6-16 characters
            </span>
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('UserId').touched &&
                registrationForm.get('UserId').hasError('pattern')
              "
              class="text text-danger"
            >
              User ID can accept only alphabets and numbers and Special
              characters
            </span>
            <span class="err-msg" *ngIf="isUserID" class="text text-danger"
              >User ID already exists</span
            >

            <span
              class="err-msg"
              *ngIf="
                !registrationForm.get('UserId').hasError('required') &&
                registrationForm.get('UserId').hasError('userIdSpace')
              "
              class="text text-danger"
              >User ID does not allows space</span
            >
          </div>
        </div>
      </div>
      <!--First Name-->
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>First Name<span class="help-block">*</span></label>
            <input
              type="text"
              class="form-control form-bg-light"
              minlength="3"
              maxlength="26"
              (keypress)="allowOnlyChars($event)"
              formControlName="FirstName"
              aria-describedby="emailHelp"
            />
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('FirstName').touched &&
                registrationForm.get('FirstName').hasError('required')
              "
              class="text text-danger"
            >
              First name is required
            </span>
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('FirstName').touched &&
                registrationForm.get('FirstName').hasError('minlength') &&
                !registrationForm.get('FirstName').hasError('required')
              "
              class="text text-danger"
            >
              Please enter minimum 3 characters</span
            >

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('FirstName').hasError('pattern') &&
                !registrationForm.get('FirstName').hasError('required') &&
                !registrationForm.get('FirstName').hasError('space')
              "
              class="text text-danger"
              >First Name Should be in Format</span
            >

            <span
              class="err-msg"
              *ngIf="
                !registrationForm.get('FirstName').hasError('required') &&
                registrationForm.get('FirstName').hasError('space') &&
                !registrationForm.get('FirstName').hasError('pattern')
              "
              class="text text-danger"
            >
              Only one space allows between the letters
            </span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label>Middle Name</label>
            <input
              type="text"
              class="form-control form-bg-light"
              minlength="3"
              maxlength="26"
              (keypress)="allowOnlyChars($event)"
              formControlName="MiddleName"
              aria-describedby="emailHelp"
            />

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('MiddleName').touched &&
                registrationForm.get('MiddleName').hasError('minlength')
              "
              class="text text-danger"
            >
              Please enter minimum 3 characters</span
            >

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('MiddleName').hasError('pattern') &&
                !registrationForm.get('MiddleName').hasError('space')
              "
              class="text text-danger"
              >Middle Name Should be in Format</span
            >

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('MiddleName').hasError('space') &&
                !registrationForm.get('MiddleName').hasError('pattern')
              "
              class="text text-danger"
            >
              Only one space allows between the letters
            </span>
          </div>
        </div>

        <!--Last Name-->
        <div class="col-md-4">
          <div class="form-group">
            <label>Last Name <span class="help-block">*</span></label>
            <input
              type="text"
              class="form-control form-bg-light"
              minlength="3"
              maxlength="20"
              (keypress)="allowOnlyChars($event)"
              formControlName="LastName"
              aria-describedby="emailHelp"
            />
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('LastName').touched &&
                registrationForm.get('LastName').hasError('required')
              "
              class="text text-danger"
            >
              Last name is required
            </span>

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('LastName').touched &&
                registrationForm.get('LastName').hasError('minlength') &&
                !registrationForm.get('LastName').hasError('required')
              "
              class="text text-danger"
            >
              Please enter minimum 3 characters</span
            >

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('LastName').hasError('pattern') &&
                !registrationForm.get('LastName').hasError('required') &&
                !registrationForm.get('LastName').hasError('space')
              "
              class="text text-danger"
              >Last Name Should be in Format</span
            >

            <span
              class="err-msg"
              *ngIf="
                !registrationForm.get('LastName').hasError('required') &&
                registrationForm.get('LastName').hasError('space') &&
                !registrationForm.get('LastName').hasError('pattern')
              "
              class="text text-danger"
            >
              Only one space allows between the letters
            </span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group flt-cal">
            <label>
              Date of birth <span class="font12">(ex: MM/DD/YYYY) </span
              ><span class="help-block">*</span>
            </label>

            <input
              type="text"
              (keyup)="dateOfBirthDate($event)"
              class="form-control form-bg-light pr-0"
              placeholder="MM/DD/YYYY"
              NumbersOnly
              formControlName="dob"
              onPaste="return false"
              onCopy="return false"
              maxlength="10"
            />

            <!-- <span class="flightcardtype "> </span> -->

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('dob').touched &&
                registrationForm.get('dob').hasError('required')
              "
              class="text text-danger"
              >Date of birth is required</span
            >

            <span
              class="help-block"
              *ngIf="
                registrationForm.get('dob').touched &&
                registrationForm.get('dob').hasError('minlength') &&
                !registrationForm.get('dob').hasError('required')
              "
              class="text text-danger"
            >
              Date of birth should be In Format
            </span>

            <span
              class="help-block text text-danger"
              *ngIf="
                registrationForm.get('dob').dirty &&
                registrationForm.get('dob').errors?.dobInvalid &&
                !registrationForm.get('dob').hasError('required') &&
                !registrationForm.get('dob').hasError('minlength')
              "
            >
              Age should be less than 100 years. Please enter a valid Date of
              Birth
            </span>

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('dob').touched &&
                registrationForm.get('dob').hasError('age') &&
                !registrationForm.get('dob').errors?.dobInvalid &&
                !registrationForm.get('dob').hasError('required') &&
                !registrationForm.get('dob').hasError('minlength')
              "
              class="text text-danger"
            >
              <span>
                Age should be less than 100 years Please enter valid date of
                birth
              </span>
            </span>
          </div>
        </div>
        <!-- <div class="col-md-6">
                    <div class="form-group">
                        <label>Country <span class="orange">(Optional)</span></label>
                        <select placeholder="Country" formControlName="countryiso2" class="form-control form-bg-light">
                            <option *ngFor="let country of countrydrop"
                                    value="{{ country.value }}">
                                {{ country.label }}
                            </option>
                        </select>
                    </div>
                </div> -->

        <div class="col-sm-4">
          <div class="form-group">
            <label>Email Address <span class="help-block">*</span></label>
            <input
              formControlName="Email"
              type="text"
              class="form-control form-bg-light"
              aria-describedby="emailHelp"
            />
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('Email').touched &&
                registrationForm.get('Email').hasError('required')
              "
              class="text text-danger"
            >
              Email is required
            </span>
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('Email').touched &&
                registrationForm.get('Email').hasError('pattern')
              "
              class="text text-danger"
            >
              Please enter a valid email address
            </span>
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('Email').touched &&
                registrationForm.get('Email').hasError('email')
              "
              class="text text-danger"
            >
              Please enter a valid email address
            </span>
          </div>
        </div>

        <!--Phone number-->
        <div class="col-sm-4">
          <div class="form-group">
            <label>Phone Number <span class="orange">(Optional)</span></label>
            <div class="row">
              <div class="col-md-6 col-lg-5 caremergency">
                <p-dropdown
                  class="signupphone"
                  [style]="{ width: '100%', height: '50px' }"
                  [options]="countrycodes"
                  formControlName="phoneCodeiso2"
                  filter="true"
                  filterBy="label,value,iso2,iso3"
                  maxlength="4"
                  emptyFilterMessage="Please Enter Valid Phone Country Code"
                  filterPlaceholder="Please Enter Country or Phone Code"
                  ariaFilterLabel="Country Code"
                  resetFilterOnHide="true"
                  (onFilter)="ShowDropdown($event)"
                >
                  <ng-template let-phonecode pTemplate="selectedItem">
                    <div class="phoneformatall2 cardetailswidth">
                      <img
                        *ngIf="phonecode.iso2"
                        src="{{ phonecode.origionalvalue }}"
                        alt="Image"
                      />
                      <span *ngIf="!phonecode.iso2">{{ phonecode.label }}</span>
                      <span *ngIf="phonecode.iso2">
                        + {{ phonecode.iso2 }}</span
                      >
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="col-md-6 col-lg-7">
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="PhoneNumber"
                    (keypress)="allowOnlyNum($event)"
                    type="text"
                    name="cpwd"
                    class="form-control form-bg-light phonenumber"
                  />

                  <span
                    class="err-msg"
                    *ngIf="
                      !registrationForm
                        .get('PhoneNumber')
                        .hasError('required') &&
                      registrationForm.get('PhoneNumber').hasError('minlength')
                    "
                    class="text text-danger"
                    >Phone number should be more than 5 digits and less than 15
                    digits.Please enter the valid phone number</span
                  >

                  <span
                    class="err-msg"
                    *ngIf="
                      !registrationForm
                        .get('PhoneNumber')
                        .hasError('required') &&
                      !registrationForm
                        .get('PhoneNumber')
                        .hasError('minlength') &&
                      registrationForm.get('PhoneNumber').hasError('pattern')
                    "
                    class="text text-danger"
                    >Phone number should be in number format</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label>Password<span class="help-block">*</span></label>
            <input
              formControlName="Password"
              name="pwd"
              type="password"
              class="form-control form-bg-light"
              maxlength="16"
            />
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('Password').touched &&
                registrationForm.get('Password').hasError('required')
              "
              class="text text-danger"
            >
              Password is required
            </span>

            <span
              *ngIf="
                registrationForm.get('Password').touched &&
                registrationForm.get('Password').hasError('minlength')
              "
              class="text text-danger"
            >
              Password Minimun 6 characters
            </span>
            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('Password').touched &&
                registrationForm.get('Password').hasError('pattern')
              "
              class="text text-danger"
            >
              Enter at least one uppercase letter, one lowercaseletter, one
              number and one special character
            </span>
          </div>
        </div>

        <!--Confirm Password-->
        <div class="col-sm-6">
          <div class="form-group">
            <label>Confirm Password<span class="help-block">*</span></label>
            <input
              formControlName="Confirmpassword"
              type="password"
              name="cpwd"
              class="form-control form-bg-light"
            />

            <span
              class="err-msg"
              *ngIf="
                registrationForm.get('Confirmpassword').touched &&
                registrationForm.get('Confirmpassword').hasError('required')
              "
              class="text text-danger"
              >Confirm password is required</span
            >
            <span
              *ngIf="
                registrationForm.get('Confirmpassword').touched &&
                registrationForm.get('Confirmpassword').hasError('mustmatch')
              "
              class="text text-danger"
              >Passwords must match</span
            >
          </div>
        </div>
      </div>

      <!--Checkbox-->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mb-2">
            <div class="custom-control custom-checkbox custom-control-inline">
              <input
                type="checkbox"
                class="custom-control-input"
                id="acceptTerms"
                formControlName="AcceptTerms"
              />
              <label
                class="form-check-label custom-control-label"
                for="acceptTerms"
              ></label>
              <p class="text-black">
                I agree to the
                <a
                  routerLink="/terms-and-conditions"
                  [target]="'_blank'"
                  class="text-underline text-orange"
                  >Terms and Conditions</a
                >
                and
                <a
                  routerLink="/privacy-policy"
                  [target]="'_blank'"
                  class="text-underline text-orange"
                  >Privacy Policy</a
                >
              </p>
              <br />
            </div>
            <p
              class="err-msg"
              *ngIf="
                registrationForm.get('AcceptTerms').touched &&
                registrationForm.get('AcceptTerms').hasError('required')
              "
              class="text text-danger"
            >
              You must accept terms & conditions
            </p>
          </div>

          <div class="row">
            <div class="alert alert-successs" *ngIf="showSuccess">
              <button
                type="button"
                data-dismiss="alert"
                aria-hidden="true"
                class="close"
              >
                �
              </button>
              <li *ngFor="let err of successMessageText">
                {{ err }}
              </li>
            </div>
            <div class="alert alert-danger" *ngIf="showFail">
              <button
                type="button"
                data-dismiss="alert"
                aria-hidden="true"
                class="close"
              >
                �
              </button>
              <li *ngFor="let err of successMessageText">
                {{ err }}
              </li>
            </div>
            <!-- <div class="col-md-5">
                            <button class="btn btn-primary btn-block" type="submit">
                                Create Your Account
                            </button>
                        </div> -->
            <div class="col-md-12 text-center">
              <div class="form-group">
                <button type="submit" class="btn btn-primary btn-lg mr-lg-3">
                  Create Your Account
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="showSuccess" class="alert alert-success">
            Registration success, please check your mail
          </div>
          <div class=" ">
            <div class="form-group mt-2">
              <div>
                <div class="" role="alert">
                  <span class="text-black"> Already have an account?</span>
                  <a
                    #signin
                    class="font600 text-orange text-underline cursor"
                    data-toggle="modal"
                    data-target="#loginModal"
                    (click)="logIn()"
                    href=""
                  >
                    Click here to Login
                  </a>
                </div>
              </div>
            </div>
          </div>
          <ng-template #signincontainer></ng-template>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #agent>
  <form
    autocomplete="off"
    [formGroup]="agentForm"
    class="payment-form-wrapper"
    (ngSubmit)="onAgentRegistrationSubmit()"
  >
    <div class="pregistrationFormt-25 ph-30">
      <div class="row gap-20 mb-0 form-container">
        <div class="col-md-12">
          <div class="form-group mt-15">
            <label>Agent ID <span class="help-block">*</span></label>
            <input
              type="text"
              class="form-control form-bg-light"
              formControlName="UserId"
              minlength="6"
              maxlength="16"
              id="uniqueUserID"
              (keyup)="checkVal()"
              (blur)="checkUserIDExist()"
            />

            <span
              class="err-msg text text-danger"
              *ngIf="getError(agentForm.get('UserId'), 'Agent ID') as errorMsg"
              >{{ errorMsg }}</span
            >

            <span class="err-msg" *ngIf="isUserID" class="text text-danger"
              >Agent ID already exists</span
            >

            <!-- <span class="err-msg" *ngIf="agentForm.get('UserId').touched && agentForm.get('UserId').hasError('required')" class="text text-danger">
                            Agent ID is required
                        </span>
                        <span class="err-msg" *ngIf="agentForm.get('UserId').touched && agentForm.get('UserId').hasError('minlength')" class="text text-danger input">
                            Agent ID between 6-16 characters
                        </span>
                        <span class="err-msg" *ngIf="agentForm.get('UserId').touched && agentForm.get('UserId').hasError('pattern')" class="text text-danger">
                            Agent ID can accept only alphabets and numbers and Special characters
                        </span>
                        <span class="err-msg" *ngIf="isUserID" class="text text-danger">Agent ID already exists
                        </span>

                        
                        <span class="err-msg" *ngIf="
                        !agentForm.get('UserId').hasError('required') &&
                        agentForm.get('UserId').hasError('userIdSpace')" class="text text-danger">User ID does not allows space</span> -->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>First Name<span class="help-block">*</span></label>
            <input
              type="text"
              class="form-control form-bg-light"
              minlength="3"
              maxlength="26"
              (keypress)="allowOnlyChars($event)"
              formControlName="FirstName"
              aria-describedby="emailHelp"
            />
            
            
            <span
              class="err-msg text text-danger"
              *ngIf="getError(agentForm.get('FirstName'), 'First Name') as errorMsg"
              >{{ errorMsg }}</span>

            <!-- <span
              class="err-msg"
              *ngIf="
                agentForm.get('FirstName').touched &&
                agentForm.get('FirstName').hasError('required')
              "
              class="text text-danger"
            >
              First name is required
            </span>
            <span
              class="err-msg"
              *ngIf="
                agentForm.get('FirstName').touched &&
                agentForm.get('FirstName').hasError('minlength') &&
                !agentForm.get('FirstName').hasError('required')
              "
              class="text text-danger"
            >
              Please enter minimum 3 characters
            </span>
            <span
              class="err-msg"
              *ngIf="
                agentForm.get('FirstName').hasError('pattern') &&
                !agentForm.get('FirstName').hasError('required') &&
                !agentForm.get('FirstName').hasError('space')
              "
              class="text text-danger"
              >First Name Should be in Format</span
            >

            <span
              class="err-msg"
              *ngIf="
                !agentForm.get('FirstName').hasError('required') &&
                agentForm.get('FirstName').hasError('space') &&
                !agentForm.get('FirstName').hasError('pattern')
              "
              class="text text-danger"
            >
              Only one space allows between the letters
            </span> -->
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Middle Name</label>
            <input
              type="text"
              class="form-control form-bg-light"
              minlength="3"
              maxlength="26"
              (keypress)="allowOnlyChars($event)"
              formControlName="MiddleName"
              aria-describedby="emailHelp"
            />

            <!-- <span
              class="err-msg"
              *ngIf="
                agentForm.get('MiddleName').touched &&
                agentForm.get('MiddleName').hasError('minlength')
              "
              class="text text-danger"
            >
              Please enter minimum 3 characters
            </span>
            <span
              class="err-msg"
              *ngIf="
                agentForm.get('MiddleName').hasError('pattern') &&
                !agentForm.get('MiddleName').hasError('space')
              "
              class="text text-danger"
              >Middle Name Should be in Format</span
            >

            <span
              class="err-msg"
              *ngIf="
                agentForm.get('MiddleName').hasError('space') &&
                !agentForm.get('MiddleName').hasError('pattern')
              "
              class="text text-danger"
            >
              Only one space allows between the letters
            </span> -->

            <span
              class="err-msg text text-danger"
              *ngIf="getError(agentForm.get('MiddleName'), 'Middle Name') as errorMsg"
              >{{ errorMsg }}</span>

        </div>
        </div>

        <!--Last Name-->
        <div class="col-md-6">
          <div class="form-group">
            <label>Last Name <span class="help-block">*</span></label>
            <input
              type="text"
              class="form-control form-bg-light"
              minlength="3"
              maxlength="20"
              (keypress)="allowOnlyChars($event)"
              formControlName="LastName"
              aria-describedby="emailHelp"
            />
            <span
              class="err-msg text text-danger"
              *ngIf="getError(agentForm.get('LastName'), 'Last Name') as errorMsg"
              >{{ errorMsg }}</span>
            <!-- <span
              class="err-msg"
              *ngIf="
                agentForm.get('LastName').touched &&
                agentForm.get('LastName').hasError('required')
              "
              class="text text-danger"
            >
              Last name is required
            </span>

            <span
              class="err-msg"
              *ngIf="
                agentForm.get('LastName').touched &&
                agentForm.get('LastName').hasError('minlength') &&
                !agentForm.get('LastName').hasError('required')
              "
              class="text text-danger"
            >
              Please enter minimum 3 characters
            </span>

            <span
              class="err-msg"
              *ngIf="
                agentForm.get('LastName').hasError('pattern') &&
                !agentForm.get('LastName').hasError('required') &&
                !agentForm.get('LastName').hasError('space')
              "
              class="text text-danger"
              >Last Name Should be in Format
            </span>

            <span
              class="err-msg"
              *ngIf="
                !agentForm.get('LastName').hasError('required') &&
                agentForm.get('LastName').hasError('space') &&
                !agentForm.get('LastName').hasError('pattern')
              "
              class="text text-danger"
            >
              Only one space allows between the letters
            </span> -->
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group flt-cal">
            <label>
              Date of birth <span class="font12"> (ex: MM/DD/YYYY)</span
              ><span class="help-block">*</span>
            </label>

            <input
              type="text"
              (keyup)="dateOfBirthDate($event)"
              class="form-control form-bg-light pr-0"
              placeholder="MM/DD/YYYY"
              NumbersOnly
              formControlName="dob"
              onPaste="return false"
              onCopy="return false"
              maxlength="10"
            />



            <span
              class="err-msg text text-danger"
              *ngIf="getError(agentForm.get('dob'), 'Date of Birth') as errorMsg"
              >{{ errorMsg }}</span>

            <!-- <span
              class="err-msg"
              *ngIf="
                agentForm.get('dob').touched &&
                agentForm.get('dob').hasError('required')
              "
              class="text text-danger"
              >Date of birth is required
            </span>

            <span
              class="help-block"
              *ngIf="
                agentForm.get('dob').touched &&
                agentForm.get('dob').hasError('minlength') &&
                !agentForm.get('dob').hasError('required')
              "
              class="text text-danger"
            >
              Date of birth should be In Format
            </span>

            <span
              class="help-block text text-danger"
              *ngIf="
                agentForm.get('dob').dirty &&
                agentForm.get('dob').errors?.dobInvalid &&
                !agentForm.get('dob').hasError('required') &&
                !agentForm.get('dob').hasError('minlength')
              "
            >
              Age should be less than 100 years. Please enter a valid Date of
              Birth
            </span>

            <span
              class="err-msg"
              *ngIf="
                agentForm.get('dob').touched &&
                agentForm.get('dob').hasError('age') &&
                !agentForm.get('dob').errors?.dobInvalid &&
                !agentForm.get('dob').hasError('required') &&
                !agentForm.get('dob').hasError('minlength')
              "
              class="text text-danger"
            >
              <span>
                Age should be less than 100 years Please enter valid date of
                birth
              </span>
            </span> -->
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label>Email Address <span class="help-block">*</span></label>
            <!-- {{ isDisabled | json }} -->
            <input
              formControlName="Email"
              type="text"
              class="form-control form-bg-light"
              [readonly]="isDisabled"
              aria-describedby="emailHelp"
            />
            <span
              class="err-msg text text-danger"
              *ngIf="getError(agentForm.get('Email'), 'Email') as errorMsg"
              >{{ errorMsg }}</span>
            <!-- <span
              class="err-msg"
              *ngIf="
                agentForm.get('Email').touched &&
                agentForm.get('Email').hasError('required')
              "
              class="text text-danger"
            >
              Email is required
            </span>
            <span
              class="err-msg"
              *ngIf="
                agentForm.get('Email').touched &&
                agentForm.get('Email').hasError('pattern')
              "
              class="text text-danger"
            >
              Please enter a valid email address
            </span>
            <span
              class="err-msg"
              *ngIf="
                agentForm.get('Email').touched &&
                agentForm.get('Email').hasError('email')
              "
              class="text text-danger"
            >
              Please enter a valid email address
            </span> -->
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <div class="row">
              <div class="col-md-5 col-lg-5 col-sm-12 caremergency">
                <label>Code <span class="help-block">*</span></label>
                <div class="ui-grid ui-grid-responsive ui-fluid signup1">
                  <p-dropdown
                    class="signupphone"
                    [style]="{ height: '50px' }"
                    [options]="countrycodes"
                    formControlName="phoneCodeiso2"
                    filter="true"
                    filterBy="label,value,iso2,iso3"
                    maxlength="4"
                    emptyFilterMessage="Please Enter Valid Phone Country Code"
                    filterPlaceholder="Please Enter Country or Phone Code"
                    ariaFilterLabel="Country Code"
                    resetFilterOnHide="true"
                    (onFilter)="ShowDropdown($event)"
                  >
                    <ng-template let-phonecode pTemplate="selectedItem">
                      <div class="phoneformatall2 cardetailswidth">
                        <img
                          *ngIf="phonecode.iso2"
                          src="{{ phonecode.origionalvalue }}"
                          alt="Image"
                        />
                        <span *ngIf="!phonecode.iso2">{{
                          phonecode.label
                        }}</span>
                        <span *ngIf="phonecode.iso2">
                          + {{ phonecode.iso2 }}</span
                        >
                      </div>
                    </ng-template>
                    <ng-template let-i="index" let-codes pTemplate="phonecode">
                      <div class="ui-helper-clearfix phoneformatall">
                        <div class="media">
                          <div class="media-left">
                            <img
                              *ngIf="codes.iso2"
                              src="{{ codes.origionalvalue }}"
                            />
                          </div>
                          <div class="media-body">
                            <p>{{ codes.label }} + {{ codes.iso2 }}</p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-dropdown>
                  <span
                    class="err-msg"
                    *ngIf="
                      agentForm.get('phoneCodeiso2').touched &&
                      agentForm.get('phoneCodeiso2').hasError('required')
                    "
                    class="text text-danger"
                    >Enter Phone Code
                  </span>
                </div>
              </div>
              <div class="col-md-6 col-lg-7 pt-15 pt-lg-0">
                <label>Phone Number <span class="help-block">*</span></label>
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="PhoneNumber"
                    (keypress)="allowOnlyNum($event)"
                    type="text"
                    name="cpwd"
                    class="form-control form-bg-light phonenumber"
                  />
                    <span
                        class="err-msg text text-danger"
                        *ngIf="getError(agentForm.get('PhoneNumber'), 'Phone Number') as errorMsg"
                        >{{ errorMsg }}</span>
                  <!-- <span
                    class="err-msg"
                    *ngIf="
                      agentForm.get('PhoneNumber').touched &&
                      agentForm.get('PhoneNumber').hasError('required')
                    "
                    class="text text-danger"
                    >Enter Phone number
                  </span>
                  <span
                    class="err-msg"
                    *ngIf="
                      !agentForm.get('PhoneNumber').hasError('required') &&
                      agentForm.get('PhoneNumber').hasError('minlength')
                    "
                    class="text text-danger"
                    >Phone number should be more than 5 digits and less than 15
                    digits.Please enter the valid phone number
                  </span>

                  <span
                    class="err-msg"
                    *ngIf="
                      !agentForm.get('PhoneNumber').hasError('required') &&
                      !agentForm.get('PhoneNumber').hasError('minlength') &&
                      agentForm.get('PhoneNumber').hasError('pattern')
                    "
                    class="text text-danger"
                    >Phone number should be in number format
                  </span> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label>Password<span class="help-block">*</span></label>
            <input
              formControlName="Password"
              name="pwd"
              type="password"
              class="form-control form-bg-light"
              maxlength="16"
            />
            <!-- <span
              class="err-msg"
              *ngIf="
                agentForm.get('Password').touched &&
                agentForm.get('Password').hasError('required')
              "
              class="text text-danger"
            >
              Password is required
            </span>

            <span
              *ngIf="
                agentForm.get('Password').touched &&
                agentForm.get('Password').hasError('minlength')
              "
              class="text text-danger"
            >
              Password Minimun 6 characters
            </span>
            <span
              class="err-msg"
              *ngIf="
                agentForm.get('Password').touched &&
                agentForm.get('Password').hasError('pattern')
              "
              class="text text-danger"
            >
              Enter at least one uppercase letter, one lowercaseletter, one
              number and one special character
            </span> -->
            <span
              class="err-msg text text-danger"
              *ngIf="getError(agentForm.get('Password'), 'Password') as errorMsg"
              >{{ errorMsg }}</span>

          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label>Confirm Password<span class="help-block">*</span></label>
            <input
              formControlName="Confirmpassword"
              type="password"
              name="cpwd"
              class="form-control form-bg-light"
            />

            <span
              class="err-msg text text-danger"
              *ngIf="getError(agentForm.get('Confirmpassword'), 'Confirm Password') as errorMsg"
              >{{ errorMsg }}</span>

            <!-- <span
              class="err-msg"
              *ngIf="
                agentForm.get('Confirmpassword').touched &&
                agentForm.get('Confirmpassword').hasError('required')
              "
              class="text text-danger"
              >Confirm password is required</span
            >
            <span
              *ngIf="
                agentForm.get('Confirmpassword').touched &&
                agentForm.get('Confirmpassword').hasError('mustmatch')
              "
              class="text text-danger"
              >Passwords must match</span
            > -->
          </div>
        </div>
      </div>
      <!-- <ng-container *ngTemplateOutlet="address"></ng-container> -->
      <div formGroupName="Address">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Street 1<span class="help-block">*</span></label>
              <input
                placeholder="Enter Street1 info"
                formControlName="street1"
                type="text"
                class="form-control form-bg-light"
                aria-describedby="street1"
              />
              <!-- <span
                *ngIf="
                  agentAddress.get('street1').touched &&
                  agentAddress.get('street1').hasError('required')
                "
                class="text text-danger"
              >
                Street info is required
              </span> -->
                <span
                    class="err-msg text text-danger"
                    *ngIf="getError(agentAddress.get('street1'), 'Street 1') as errorMsg"
                    >{{ errorMsg }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Street 2</label>
              <input
                placeholder="Enter Street2 info"
                formControlName="street2"
                type="text"
                class="form-control form-bg-light"
                aria-describedby="street2"
              />
            <span
                  class="err-msg text text-danger"
                  *ngIf="getError(agentAddress.get('street2'), 'Street 2') as errorMsg"
                  >{{ errorMsg }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Country<span class="help-block">*</span></label>


                <p-dropdown
                  class="signupphone"
                  [style]="{ width: '100%', height: '50px' }"
                  [options]="countrydrop"
                  formControlName="country"
                  ariaFilterLabel="Country Code"
                  resetFilterOnHide="true"
                  filter="true"
                  filterBy="label,value"
                  (onChange)="getStates($event, 'state1')"
                >
                </p-dropdown>



                <!-- <p-dropdown
                          formControlName="contacttype"
                          placeholder="Select Country"
                          [style]="{ width: '105%' }"
                          [panelStyle]="{ width: '105%' }"
                          [options]="countrydrop"
                          filterBy="label"
                        >
                        </p-dropdown> -->
              
              <!-- <select
                (change)="getStates($event, 'state1')"
                placeholder="Select Country"
                formControlName="country"
                class="form-control form-bg-light truncate-select"
              >
                <option
                  *ngFor="let country of countrydrop"
                  value="{{ country.value }}"
                >
                  {{ country.label }}
                </option>
              </select> -->
              <!-- <span
                *ngIf="
                  agentAddress.get('country').touched &&
                  agentAddress.get('country').hasError('required')
                "
                class="text text-danger"
              >
                Country is required
              </span> -->
                <span
                    class="err-msg text text-danger"
                    *ngIf="getError(agentAddress.get('country'), 'Country') as errorMsg"
                    >{{ errorMsg }}</span>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
            <label
              >State

              <ng-container *ngIf="validator('state1')">
                <span class="starclr">* </span>
              </ng-container>
            </label>

            <p-dropdown
              class="signupphone"
              [style]="{ width: '100%', height: '50px' }"
              [options]="stateList1"
              formControlName="state"
              ariaFilterLabel="State"
              resetFilterOnHide="true"
              filter="true"
              aria-placeholder="Select State"
              filterBy="label,value">
            </p-dropdown>

             <span
                    class="err-msg text text-danger"
                    *ngIf="getError(agentAddress.get('state'), 'State') as errorMsg"
                    >{{ errorMsg }}</span>

          </div>
            <!-- <select
              formControlName="state"
              placeholder="Select State"
              class="form-control form-bg-light"
              tabindex="2"
            >
              <option value="" selected>Select State</option>
              <option
                value="{{ state.state_Code }}"
                *ngFor="let state of stateList1"
              >
                {{ state.state_Name }}
              </option>
            </select> -->
            <!-- <span
              *ngIf="
                agentAddress.get('state').touched &&
                agentAddress.get('state').hasError('required')
              "
              class="text text-danger"
            >
              State is required
            </span> -->
               

          </div>
          <div class="col-md-4">
            <label>City<span class="help-block">*</span></label>
            <input
              placeholder="Enter City"
              formControlName="city"
              type="text"
              class="form-control form-bg-light"
              aria-describedby="city"
            />
            <!-- <span
              *ngIf="
                agentAddress.get('city').touched &&
                agentAddress.get('city').hasError('required')
              "
              class="text text-danger"
            >
              City is required
            </span> -->
                <span
                    class="err-msg text text-danger"
                    *ngIf="getError(agentAddress.get('city'), 'City') as errorMsg"
                    >{{ errorMsg }}</span>

          </div>
          <div class="col-md-4">
            <label>Zip<span class="help-block">*</span></label>
            <input
              placeholder="Enter Zip"
              formControlName="zip"
              type="text"
              class="form-control form-bg-light"
              aria-describedby="zip"
            />
            <!-- <span
              *ngIf="
                agentAddress.get('zip').touched &&
                agentAddress.get('zip').hasError('required')
              "
              class="text text-danger"
            >
              Zip is required
            </span> -->
            <span
              class="err-msg text text-danger"
              *ngIf="getError(agentAddress.get('zip'), 'Zip') as errorMsg"
              >{{ errorMsg }}</span
            >
          </div>
        </div>
      </div>

      <!-- Organization -->
      <!-- <div class="shortresultdesc">
                <div class="row">
                    <div class="col org-title">
                        Organization Details
                    </div>
                    <div class="col text-right">
                        <a data-toggle="collapse" data-target="#orgCollapse" aria-expanded="false" class="btn-toggle searchbuttonupdate float-right pr-0">
                            <i class="downarrowblue"></i>
                        </a>
                    </div>

                </div>
            </div> -->
      <div id="orgCollapse" class="collapse mx-3">
        <div formGroupName="Organization">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Name</label>
                <input
                  formControlName="name"
                  placeholder="Enter organisation name"
                  type="text"
                  class="form-control form-bg-light"
                  aria-describedby="name"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Industry Type</label>
                <p-dropdown
                  class="signupphone"
                  [style]="{ 'min-width': '82px', height: '45px' }"
                  [options]="organizationTypes"
                  formControlName="type"
                  optionLabel="industryType"
                  optionValue="id"
                >
                </p-dropdown>
              </div>
            </div>
            <div
              class="col-md-6"
              *ngIf="
                organization?.get('type')?.value?.industryType === 'Travel'
              "
            >
              <div class="form-group">
                <label>License </label>
                <input
                  formControlName="license"
                  placeholder="License Number"
                  type="text"
                  class="form-control form-bg-light"
                  aria-describedby="license"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Description</label>
                <textarea
                  formControlName="description"
                  placeholder="Describe your business"
                  class="form-control form-bg-light"
                  aria-describedby="description"
                ></textarea>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>No. of Employees</label>
                <input
                  placeholder="Enter no. of employees"
                  formControlName="noOfEmployees"
                  type="number"
                  class="form-control form-bg-light"
                  aria-describedby="noOfEmployees"
                />
              </div>
            </div>
          </div>
          <div formGroupName="address">
            <!-- <ng-container *ngTemplateOutlet="address"></ng-container> -->

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Street 1</label>
                  <input
                    formControlName="street1"
                    placeholder="Enter Street1"
                    type="text"
                    class="form-control form-bg-light"
                    aria-describedby="street1"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Street 2</label>
                  <input
                    formControlName="street2"
                    placeholder="Enter Street2"
                    type="text"
                    class="form-control form-bg-light"
                    aria-describedby="street2"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Country</label>
                  <select
                    (change)="getStates($event, 'state2')"
                    placeholder="Select Country"
                    formControlName="country"
                    class="form-control form-bg-light"
                  >
                    <option
                      *ngFor="let country of countrydrop"
                      value="{{ country.value }}"
                    >
                      {{ country.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>State</label>
                  <select
                    formControlName="state"
                    placeholder="Select State"
                    class="form-control form-bg-light"
                    tabindex="2"
                  >
                    <option value="null" selected>Select State</option>
                    <option
                      value="{{ state.state_Code }}"
                      *ngFor="let state of stateList2"
                    >
                      {{ state.state_Name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>City</label>
                  <input
                    placeholder="Enter City"
                    formControlName="city"
                    type="text"
                    class="form-control form-bg-light"
                    aria-describedby="city"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Zip</label>
                  <input
                    placeholder="Enter Zip"
                    formControlName="zip"
                    type="text"
                    class="form-control form-bg-light"
                    aria-describedby="city"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Organization End -->
      </div>

      <!--Checkbox-->
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="form-group mb-2">
            <div class="custom-control custom-checkbox custom-control-inline">
              <input
                type="checkbox"
                class="custom-control-input"
                id="acceptTerms"
                formControlName="AcceptTerms"
              />
              <label
                class="form-check-label custom-control-label"
                for="acceptTerms"
              ></label>
              <p class="text-black">
                By clicking Create Your Account, you agree to our
                <a
                  routerLink="/privacy-policy"
                  [target]="'_blank'"
                  class="text-underline text-orange"
                  >Privacy Policy</a
                >
                and

                <a
                  routerLink="/terms-and-conditions"
                  [target]="'_blank'"
                  class="text-underline text-orange"
                  >Terms and Service</a
                >
              </p>
              <br />
            </div>
            <p
              *ngIf="
                agentForm.get('AcceptTerms').touched &&
                agentForm.get('AcceptTerms').hasError('required')
              "
              class="err-msg text text-danger"
            >
              You must accept terms & conditions
            </p>
          </div>

          <div class="row">
            <div class="alert alert-successs" *ngIf="showSuccess">
              <button
                type="button"
                data-dismiss="alert"
                aria-hidden="true"
                class="close"
              >
                �
              </button>
              <li *ngFor="let err of successMessageText">
                {{ err }}
              </li>
            </div>
            <div class="alert alert-danger" *ngIf="showFail">
              <button
                type="button"
                data-dismiss="alert"
                aria-hidden="true"
                class="close"
              >
                �
              </button>
              <li *ngFor="let err of successMessageText">
                {{ err }}
              </li>
            </div>
            <!-- <div class="col-md-5">
                            <button class="btn btn-primary btn-block" type="submit">
                                Register Agent
                            </button>
                        </div> -->
            <div class="col-md-12 text-center">
              <div class="form-group">
                <button type="submit" class="btn btn-primary btn-lg mr-lg-3">
                  Create Your Account
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="showSuccess" class="alert alert-success">
            Registration success, please check your mail
          </div>
          <div class=" ">
            <div class="form-group mt-2">
              <div>
                <div class="" role="alert">
                  <span class="text-black"> Already have an account?</span>
                  <a
                    #signin
                    class="font600 text-orange text-underline cursor"
                    data-toggle="modal"
                    data-target="#loginModal"
                    (click)="logIn()"
                    href=""
                  >
                    Click here to Login
                  </a>
                </div>
              </div>
            </div>
          </div>
          <ng-template #signincontainer></ng-template>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #address> </ng-template>
